/*import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

// Navbar
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Categories from './pages/Categories';
import CategoryDetails from './pages/CategoryDetails';
import Nominee from './pages/Nominee';
import Nominate from './pages/Nominate';
import Vote from './pages/Vote';
import Admin from './admin/Admin';
import AdminLogin from './admin/AdminLogin';

// Pages


// Helper to reset scroll on page change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="bg-black min-h-screen text-white selection:bg-[#D4AF37] selection:text-black">
        <Navbar />
        
        {/* Adds padding-top so content isn't hidden behind the fixed navbar *//*
        <main className="pt-20">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/category/:id" element={<CategoryDetails />} />
            <Route path="/nominee/:id" element={<Nominee />} />
            <Route path="/nominate" element={<Nominate />} />
            <Route path="/vote/:slug" element={<Nominee />} />
            <Route path="/vote-now/:id" element={<Vote />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin-login" element={<AdminLogin />} />
          </Routes>
        </main>

      </div>
    </Router>
  );
}

export default App;*/


import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

// Components & Pages
import Navbar from './components/Navbar';
import Footer from './components/Footer'; // Added Footer back since it's global
import Home from './pages/Home';
import Categories from './pages/Categories';
import CategoryDetails from './pages/CategoryDetails';
import Nominee from './pages/Nominee';
import Nominate from './pages/Nominate';
import Vote from './pages/Vote';
import Admin from './admin/Admin';
import AdminLogin from './admin/AdminLogin';
import Leaderboard from './pages/Leaderboard';
import Legal from './pages/Legal';

// Helper to reset scroll on page change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// --- THIS IS THE NEW COMPONENT ADDED ---
const AppContent = () => {
  const location = useLocation();
  
  // Logic: Check if the current URL path starts with "/admin"
  // This covers both "/admin" and "/admin-login"
  const isAdminPage = location.pathname.startsWith('/admin');

  return (
    <div className="bg-black min-h-screen text-white selection:bg-[#D4AF37] selection:text-black">
      
      {/* 1. Show Navbar ONLY if it is NOT an admin page */}
      {!isAdminPage && <Navbar />}
      
      {/* 2. Adjust padding: Admin pages don't need the 'pt-20' meant for the fixed navbar */}
      <main className={!isAdminPage ? "pt-20" : ""}>
        {/*<Routes>
          <Route path="/" element={<Home />} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/category/:id" element={<CategoryDetails />} />
          <Route path="/nominee/:id" element={<Nominee />} />
          <Route path="/nominate" element={<Nominate />} />
          <Route path="/vote/:slug" element={<Nominee />} />
          <Route path="/vote-now/:id" element={<Vote />} />
          
      
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin-login" element={<AdminLogin />} />
        </Routes>*/}

        <Routes>
  <Route path="/" element={<Home />} />
  <Route path="/categories" element={<Categories />} />
  <Route path="/legal" element={<Legal />} />
  
  {/* STEP 2: This route must match the link in your Categories page */}
  <Route path="/nominees/:id" element={<CategoryDetails />} /> 
  
  {/* STEP 3: This route is for the individual profiles */}
  <Route path="/vote/:slug" element={<Nominee />} />
  
  <Route path="/nominate" element={<Nominate />} />
  <Route path="/vote-now/:id" element={<Vote />} />
  <Route path="/pulse" element={<Leaderboard />} />
  
  <Route path="/admin" element={<Admin />} />
  <Route path="/admin-login" element={<AdminLogin />} />
</Routes>
      </main>

      {/* 3. Show Footer ONLY if it is NOT an admin page */}
      {/*!isAdminPage && <Footer />*/}
    </div>
  );
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      {/* We call the logic component here inside the Router */}
      <AppContent />
    </Router>
  );
}

export default App;